import { Badge } from '@/components/ui/badge';
import { getStatusTone } from '@/lib/theme-palette';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

function resolveClasses(status: string): string {
  const tone = getStatusTone(status);

  if (tone === 'success') {
    return 'border-transparent bg-status-success/15 text-status-success';
  }

  if (tone === 'warning') {
    return 'border-transparent bg-status-warning/20 text-status-warning';
  }

  if (tone === 'danger') {
    return 'border-transparent bg-status-danger/15 text-status-danger';
  }

  return 'border-transparent bg-status-neutral/20 text-status-neutral';
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge className={cn(resolveClasses(status), className)} variant="outline">
      {status}
    </Badge>
  );
}

